import React from 'react';
import { ReachButton } from '../../../components/ReachButton/ReachButton';
import './ArticleButtons.scss';

export const ArticleButtons = ({ prev, next }) => {
    return (
        <nav className="article-nav" >
            {prev &&
                <ReachButton 
                    href={prev}
                    buttonStyle="borderless"
                    buttonIcon={{
                        icon: `ki-arrow-left`,
                        position: `left`,
                    }}
                >
                    Previous Article
                </ReachButton>
            }
            {next && 
                <ReachButton 
                    href={next}
                    className="next-article"
                    buttonStyle="borderless"
                    buttonIcon={{
                        icon: `ki-arrow-right`,
                        position: `right`,
                    }}
                >
                    Next Article
                </ReachButton>
            }
        </nav>
    );
}